// UserRole - Matches C# Earlymed.Enums.UserRole
export enum UserRole {
  Student = 0,
  Medic = 1,
  Admin = 2,
}

// Helper function to get role name from enum value
export function getUserRoleName(role: UserRole): string {
  return UserRole[role];
}

// Helper function to get role enum from string (case-insensitive)
export function getUserRoleFromString(roleString: string): UserRole | undefined {
  const upperRole = roleString.toLowerCase();
  if (upperRole === 'student') return UserRole.Student;
  if (upperRole === 'medic') return UserRole.Medic;
  if (upperRole === 'Admin') return UserRole.Admin;
  return undefined;
}

// Array of all role names for UI
export const USER_ROLE_NAMES = ['Student', 'Medic', 'Admin'] as const;
